import { useCallback, useState } from 'react';

export type UseTabsStateResult = ModelHookResult<
	{
		selectedTab: string;
	},
	{
		changeSelectedTab: (tab: string, callback?: (prev: string) => void) => void;
	}
>;

export function useTabsState(): UseTabsStateResult {
	const [selectedTab, setSelectedTab] = useState('home');

	const changeSelectedTab = useCallback(
		(tab: string, callback?: (prev: string) => void) => {
			setSelectedTab((prev) => {
				if (callback) {
					callback(prev);
				}
				return tab;
			});
		},
		[setSelectedTab],
	);

	return {
		data: {
			selectedTab,
		},
		actions: {
			changeSelectedTab,
		},
	};
}
